import React from 'react';

import { FullscreenModal } from '@infinex-private/connect-web-shared/components';
import { InfoIcon } from '@infinex/ui-icons';
import { Text } from '@infinex/ui/components';

interface MaliciousTransactionDetailsProps {
  description: string;
  onBack: () => void;
}

export function MaliciousTransactionDetails({
  description,
  onBack,
}: MaliciousTransactionDetailsProps) {
  return (
    <FullscreenModal
      onBack={onBack}
      className="bg-canvas size-full rounded-none"
    >
      <div className="flex-1 p-4">
        <InfoIcon fill="critical" className="my-2 size-8" />
        <Text className="text-emphasis text-2xl font-semibold">
          Malicious Transaction
        </Text>

        <div className="bg-surface mt-6 rounded-3xl p-5">
          <Text className="text-default text-sm/relaxed">
            This transaction was flagged as malicious by Blockaid. {description}
            .
          </Text>

          <div className="mt-6">
            <Text className="text-default items-center pt-4 text-center text-sm font-medium">
              Learn more about
              <button
                type="button"
                onClick={() => {
                  window.open('https://blockaid.io/', '_blank');
                }}
                className="text-default cursor-pointer underline hover:opacity-80"
              >
                <span className="mx-1">Blockaid</span>
              </button>
            </Text>
          </div>
        </div>
      </div>
    </FullscreenModal>
  );
}
